export enum TerminatorType {
    UnixStyle = "unix-style",
    WindowsStyle = "windows-style",
}

export const terminatorTypeOptions = [
    { id: TerminatorType.UnixStyle, name: "Unix style" },
    { id: TerminatorType.WindowsStyle, name: "Windows style" },
];
